import {ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewChild} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {FormBuilder, FormControl} from "@angular/forms";
import {appInjector} from "../../../index";
import {AutocompleteComponent} from "../../../core/visbos-core/ui/forms/autocomplete/autocomplete.component";
import {Product} from "../../../shared/view-model/store-management/product.type";
import {Packing} from "../../../shared/view-model/store-management/packing.type";
import {SessionActions} from "../../../shared/actions";

@Component({
  selector: 'vb-stock-item-input-field',
  templateUrl: './stock-item-input-field.component.html',
  styleUrls: ['./stock-item-input-field.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => StockItemInputFieldComponent)}]
})
export class StockItemInputFieldComponent extends AbstractVisbosControl<StockItem, FormControl> implements OnInit {

  @ViewChild('inputField')
  inputField: AutocompleteComponent<StockItem>;

  @Input()
  stockItemList: StockItem[] = [];

  @Input()
  loading: boolean;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions)
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(): FormControl {
    return StockItemInputFieldComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  focus() {
    this.inputField.focus();
  }

  searchLabelAndArticleNumber(searchString: string, items: StockItem[]): StockItem[] {

    if (!searchString || !items) {
      return items || [];
    }

    // Search for name
    return items.filter((item: StockItem) => {
      let label = item.label.toLowerCase();
      if (label.includes(searchString.toLowerCase())) {
        return true;
      }

      // Search for article no
      let artNos = [];
      item.products.forEach((prod: Product) => {
        prod.packings.forEach((pack: Packing) => {
          if (pack.article_number) {
            artNos.push(pack.article_number.toLowerCase());
          }
        })
      });
      if (artNos.find(no => no.includes(searchString.toLowerCase()))) {
        return true;
      }

      return false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock-item/stock-item-input-field/stock-item-input-field.component.ts